import React from 'react';
import { Image, Text, View } from 'react-native-web';
import {
  getMediumFont, getRef, getRegularFont, LocStr,
} from '../../../../utils/Utils';
import {
  Biometric_Face_ID,
  cancel_str,
  Face_ID,
  Try_Again,
  Try_Face_Again,
} from '../../../../utils/DictionaryManagementUtils';
import { img_icon_face_id } from '../../../../utils/ImagesManagementUtils';
import ClearPageWithCenterIconFP from './ClearPageWithCenterIconFP';

//= ========================================================================
const ClearPageWithCenterIconErrorFP = ({
  globJSON,
  simPlatform,
  notSkipped,
  language,
  slideshowRefs,
}) => {
  const myStyles = {
    container: {
      width: 174,
      height: 167,
      alignSelf: 'center',
      position: 'absolute',
      marginTop: 170,
      zIndex: 2,
      borderRadius: 9,
      backgroundColor: 'rgba(248,248,248,1.0)',
    },
    faceImageStyle: {
      alignSelf: 'center',
      marginTop: 19,
      width: 42,
      height: 42,
      tintColor: '#007aff',
    },
    faceTxt: {
      paddingVertical: 6,
      textAlign: 'center',
      fontSize: 10.9,
      color: '#000',
      fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
    },
    txtTryAgainStyle: {
      textAlign: 'center',
      fontSize: 8.3,
      color: '#000',
      fontFamily: `${getRegularFont(globJSON, simPlatform)}`,
      marginBottom: 10,
    },
    lineStyle: {
      width: 174,
      height: 1,
      marginBottom: 5,
      marginLeft: 0,
      backgroundColor:
                'rgba(0,0,80,0.35)',
    },
    linkStyle: {
      textAlign: 'center',
      fontSize: 10.9,
      color: '#007aff',
      fontFamily: `${getMediumFont(globJSON, simPlatform)}`,
      marginBottom: 5,
    },
    shadowPage: {
      width: 240,
      height: 520,
      marginTop: 20,
      marginLeft: 0,
      position: 'absolute',
      backgroundColor: '#000',
      opacity: 0.4,
    },
  };

  return (
    <View ref={getRef(slideshowRefs)}>
      <View
        style={myStyles.container}
      >
        <Image
          style={myStyles.faceImageStyle}
          fadeDuration={0}
          source={img_icon_face_id}
        />
        <Text style={myStyles.faceTxt}>
          {LocStr(Face_ID, language)}
        </Text>
        <Text style={myStyles.txtTryAgainStyle}>
          {LocStr(Try_Again, language)}
        </Text>
        <View style={myStyles.lineStyle} />
        <Text style={myStyles.linkStyle}>
          {LocStr(Try_Face_Again, language)}
        </Text>
        <View
          style={myStyles.lineStyle}
        />
        <Text style={myStyles.linkStyle}>
          {LocStr(cancel_str, language)}
        </Text>
      </View>
      <ClearPageWithCenterIconFP
        globJSON={globJSON}
        simPlatform={simPlatform}
        notSkipped={notSkipped}
        imageInsidePage={img_icon_face_id}
        TopTitle={Biometric_Face_ID}
      />
      <View
        style={myStyles.shadowPage}
      />
    </View>
  );
};

export default ClearPageWithCenterIconErrorFP;
